export default __webpack_public_path__ + "locales/fr/ChangeUserTypeDialog.json?hash=288cce6098175ef40cfcbd6e999b0834";